import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { ResetPasswordFormContainer } from "@platform/features/auth";
import { AuthPageContent } from "@themes/pollinator/ui/AuthPageContent";

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const oobCode = searchParams.get("oobCode");
  const [isSuccess, setIsSuccess] = useState(false);

  const onCancel = () => {
    navigate("/login");
  };

  return (
    <AuthPageContent
      title={isSuccess ? "Password Reset" : "Set New Password"}
      description={
        isSuccess
          ? "Your password has been successfully reset."
          : "Your new password must be different from previously used passwords."
      }
    >
      <ResetPasswordFormContainer
        oobCode={oobCode || ""}
        onSuccess={() => setIsSuccess(true)}
        renderActions={({ isSubmitting, isValid, isSuccess, onSubmit }) => (
          <>
            {!isSuccess && (
              <Button
                variant="primary"
                onClick={onSubmit}
                disabled={isSubmitting || !isValid}
                type="submit"
              >
                Reset Password
              </Button>
            )}
          </>
        )}
      />
      <Button variant="link" iconComponent={ArrowLeft} onClick={onCancel}>
        Back to Login
      </Button>
    </AuthPageContent>
  );
}

export default ResetPasswordPage;
